import styles from "./Home.module.scss";
import { NavLink, useLocation } from 'react-router-dom';

// @ts-ignore
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import * as React from "react";
import { ReactComponent as HomeLogo } from '../../styles/nav_icons/home.svg';
import { ReactComponent as BenchmarkLogo } from '../../styles/nav_icons/benchmark_icon.svg';
import { ReactComponent as ScanLogo } from '../../styles/nav_icons/analysis.svg';
import { ReactComponent as LibraryLogo } from '../../styles/nav_icons/library_books.svg';
import { ReactComponent as ProgressLogo } from '../../styles/nav_icons/monitoring.svg';
import { ReactComponent as DashboardLogo } from '../../styles/nav_icons/dashboard.svg';
import { ReactComponent as ResourceLogo } from '../../styles/nav_icons/school.svg';
import {useContext} from "react";
import {UserContext} from "../../context/UserContext";

enum Routes {
    HOME = '/library/home',
    SCANS = '/library/scans',
    STARTUPS = '/library/startups',
    PROGRESS = '/library/progress',
    PORTFOLIODASHBOARD = '/library/portfoliodashboard',
    BENCHMARK = '/library/benchmark',
    LEARNING = '/library/learning',
    ORGANISATIONS = '/admin/organisations',
    TEST = '/admin/test/report'
}

export const Home = () => {
    const userContext = useContext(UserContext)
    const location = useLocation();
    const isSuperAdmin = userContext?.organisation?.id === 1;
    const isAdmin = userContext?.role === "ADMIN";
    const isStartup = userContext?.role === "STARTUP";
    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="" subtitle=""/>

            {/*<div className={styles.flexGrid} style={{height:"20%"}}>*/}
            {/*    <div className={styles.col}>*/}
            {/*        <span><br/></span>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<br/>*/}
            <div className={styles.flexGrid}>
                <div className={styles.col}>
                    <span style={{fontSize:50}}>Get started in the Start-up library</span>
             </div>
            </div>
            <div className={styles.flexGridThirds}>
                <div className={styles.col}>
                    <NavLink to={Routes.SCANS} >
                        <ScanLogo className={styles.icon}/><br/>
                        <div className={styles.title}>
                            Analysis
                        </div>
                        <div className={styles.show} >
                            <div className={styles.hide}> Start or send out scans.</div>
                        </div>
                    </NavLink>
                </div>
                <div className={styles.col}>
                    <NavLink to={Routes.STARTUPS} >
                        <LibraryLogo className={styles.icon}/><br/>
                        <div className={styles.title}>
                            Library
                        </div>
                        <div className={styles.show} >
                            <div className={styles.hide}> Add labels to scans & track & trace scan invites.
                            </div>
                        </div>
                    </NavLink>
                </div>
                <div className={styles.col}>
                    <NavLink to={Routes.PROGRESS} >
                        <ProgressLogo className={styles.icon}/><br/>
                        <div className={styles.title}>
                            Review
                        </div>
                        <div className={styles.show} >
                            <div className={styles.hide}> Review scan results.
                            </div>
                        </div>
                    </NavLink>
                </div>
            </div>
            <div className={styles.flexGridThirds}>
                {
                    isAdmin && <>
                        <div className={styles.col}>
                            <NavLink to={Routes.PORTFOLIODASHBOARD} >
                                <DashboardLogo className={styles.icon}/><br/>
                                <div className={styles.title}>
                                    Portfolio dashboard
                                </div>
                                <div className={styles.show} >
                                    <div className={styles.hide}> Get an overview of insights on your companies.
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    </>
                }
                <div className={styles.col}>
                    <NavLink to={Routes.BENCHMARK} >
                        <BenchmarkLogo className={styles.icon}/><br/>
                    <div className={styles.title}>
                        Benchmark
                    </div>
                    <div className={styles.show} >
                        <div className={styles.hide}> Check progress and compare to benchmark.
                        </div>
                    </div>
                    </NavLink>
                </div>
                <div className={styles.col}>
                    <NavLink to={Routes.LEARNING} >
                        <ResourceLogo className={styles.icon}/><br/>
                        <div className={styles.title}>
                            Learning
                        </div>
                        <div className={styles.show} >
                            <div className={styles.hide} id={"centertext"}> Learn about the Startup-Framework.
                            </div>
                        </div>
                    </NavLink>
                </div>
            </div>

        </div>
    )
}